var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "d-flex align-items-center mb-3" }, [
        _vm.icon
          ? _c("img", {
              staticClass: "mr-2",
              attrs: {
                src: "/images/svg/" + _vm.icon + ".svg",
                height: "24",
                "aria-hidden": "true",
                alt: ""
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _c("h3", { staticClass: "section-title" }, [_vm._v(_vm._s(_vm.title))])
      ]),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }